import React, { useState, useEffect} from "react";
import Navbar from "../../components/Navbar/Navbar";
import ScrollToTopButton from "../../components/ScrollToTopButton/ScrollToTopButton";
import DarkModeButton from "../../components/DarkModeButton/DarkModeButton";
import "./Contact.css";

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    topic: "kerdes",
    message: "",
    frequency: "",
    webinar: true,      // alapból bepipálva
    newsletter: true,   // alapból bepipálva
    agree: false,
  });
  const [charCount, setCharCount] = useState(0);
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
      document.title = "Kútonline - Kapcsolat";
    }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
    if (name === "message") setCharCount(value.length);
  };

  const handleReset = (e) => {
    e.preventDefault();
    setForm({
      name: "",
      email: "",
      topic: "kerdes",
      message: "",
      frequency: "",
      webinar: true, 
      newsletter: true,   
      agree: false,
    });
    setCharCount(0);
  };

  // Submit to PHP backend
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      // Convert booleans to string for PHP
      formData.append(key, typeof value === 'boolean' ? value.toString() : value);
    });
    // Newsletter API call if checked
    if (form.newsletter && form.email) {
      try {
        await fetch(`${apiUrl}/newsletter/subscribe`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify({ email: form.email })
        });
      } catch (err) {
        console.error('Hírlevél feliratkozás hiba:', err);
      }
    }
    fetch('/contact.php', {
      method: 'POST',
      body: formData
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          alert("Köszönjük, hogy felvette velünk a kapcsolatot!");
          handleReset(e);
        } else {
          console.error('Hiba a kapcsolatfelvételi űrlap küldésekor:', data);
          alert(data.message || "Hiba történt az üzenet küldésekor. Próbáld újra később.");
        }
      })
      .catch((err) => {
        console.error('Hiba a kapcsolatfelvételi űrlap küldésekor:', err);
        alert("Hiba történt az üzenet küldésekor. Próbáld újra később.");
      });
  };

  return (
    <div>
      <Navbar />
      <DarkModeButton />
      <div className="page-container contact-container">
        <h2>Kérdésed van? Keress bátran!</h2>
        <form onSubmit={handleSubmit}>
          <div className="inner-container">
            <label htmlFor="name" className="form-label">Név</label><br />
            <input type="text" id="name" name="name" className="form-control" maxLength={50} placeholder="Gipsz Jakab" required value={form.name} onChange={handleChange} /><br />

            <label htmlFor="email" className="form-label">Email cím, ahol elérhetünk</label><br />
            <input type="email" id="email" name="email" className="form-control" maxLength={70} placeholder="gibszjakab@kutonline.hu" required value={form.email} onChange={handleChange} /><br />

            <label htmlFor="topic" className="form-label">Téma</label><br />
            <select id="topic" name="topic" className="form-select" value={form.topic} onChange={handleChange}>
              <option value="kerdes">Kérdés</option>
              <option value="visszajelzes">Visszajelzés</option>
              <option value="hiba">Hibajelentés</option>
            </select><br />

            <label htmlFor="message" className="form-label">Üzenet</label><br />
            <textarea id="message" name="message" className="form-control" rows={4} placeholder="Röviden írd le miben segíthetünk!" maxLength={1500} value={form.message} onChange={handleChange}></textarea>
            <div id="charCount">Karakterek: {charCount} / 1500</div><br />

            <label className="form-label">Milyen gyakran látogatod meg oldalunkat?</label>
            <div>
              <input type="radio" id="daily" name="frequency" value="naponta" checked={form.frequency === "naponta"} onChange={handleChange} />
              <label htmlFor="daily">Naponta</label>
            </div>
            <div>
              <input type="radio" id="weekly" name="frequency" value="hetente" checked={form.frequency === "hetente"} onChange={handleChange} />
              <label htmlFor="weekly">Hetente</label>
            </div>
            <div>
              <input type="radio" id="monthly" name="frequency" value="havonta" checked={form.frequency === "havonta"} onChange={handleChange} />
              <label htmlFor="monthly">Havonta</label>
            </div>
            <div>
              <input type="radio" id="rarely" name="frequency" value="ritkán" checked={form.frequency === "ritkán"} onChange={handleChange} />
              <label htmlFor="rarely">Ritkán</label>
            </div><br />


            <input type="checkbox" id="webinar" name="webinar" checked={form.webinar} onChange={handleChange} />
            <label htmlFor="webinar" className="form-label">Érdekelnek a programjaink?</label><br />
            <input type="checkbox" id="newsletter" name="newsletter" checked={form.newsletter} onChange={handleChange} />
            <label htmlFor="newsletter" className="form-label">Feliratkozom a hírlevélre.</label><br/>         
            <div id="adatkezelesi-check-container">
              <input type="checkbox" id="agree" name="agree" checked={form.agree} onChange={handleChange} required/>
              <label for="agree">Elolvastam és elfogadom az <a href="/privacypolicy" target="_blank">adatkezelési tájékoztatót</a><span className="mandatory-field">*</span></label>
           
            </div>
            <br />
  
          </div>
          <div className="contact-button-container">
            <button type="reset" id="resetBtn" className="btn btn-danger" onClick={handleReset}>Törlés</button>
            <button type="submit" className="btn btn-primary">Küldés</button>
          </div>

        </form>
        <p className="page-container contact-container_thx">Köszönjük, hogy felvetted velünk a kapcsolatot! Hamarosan válaszolunk.</p>
      </div>
    
    <ScrollToTopButton />
  </div>
  )}
